import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
    name: "FacilityUsersRoles",
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            dialog: false,
            roleName: '',
            loading: false,
            roles: [],
            rolesDeleteIds: [],
            disabled: true
        }
    },
    computed: {
        usersRoles() {
            return this.$store.state.userModule.usersRoles;
        }
    },
    methods: {
        open() {
            this.dialog = true;
        },
        cancel() {
            this.dialog = false;
        },
        async saveUsersRoles() {
            this.loading = true;

            if(this.rolesDeleteIds.length) {
                for(const id of this.rolesDeleteIds) {
                    await this.$store.dispatch("deleteUserRole", id)
                }
            }

            const changedRoles = this.roles.filter(x => x.changed && x.id);
            if(changedRoles.length > 0){
                for(const role of changedRoles) {
                    await this.$store.dispatch("updateUserRole", role)
                }
            }

            this.loading = false;
            this.dialog = false;

        },
        updateRole(role) {
            role.changed = true;
            this.$forceUpdate();
            this.disabled = false;
        },
        removeRole(role) {
            this.roles = this.roles.filter(x => x.id !== role.id);
            this.rolesDeleteIds.push(role.id);
            this.disabled = false;
        },
    },
    created() {
        this.$store.dispatch("getUsersRoles");
    },
    watch:{
        usersRoles(){
            this.roles = this.usersRoles
        }
    },
}